// extracted by mini-css-extract-plugin
export default {"pageTitle":"page_title_pageTitle__NCHZF","boldLabel":"page_title_boldLabel__pB2ZR","link":"page_title_link__yvRqW","disabled":"page_title_disabled__+x8IV"};